module.exports = __webpack_public_path__ + "img/myAdvertise.a51b37b3.png";